module.exports = __webpack_public_path__ + "static/media/class.0cd9134e.jpg";